import './index.css'
interface Props {
  onAccept: () => void
  onReject: () => void
}

export default function CookieBanner({ onAccept, onReject }: Props) {
  return (
    <div className="bc-cookie-banner" role="dialog" aria-label="Consentimento de cookies">
      <p className="bc-cookie-banner__text">
        Usamos cookies analíticos para entender como você usa o bagcash e melhorar sua experiência.
        Veja nossa{' '}
        <a href="/privacidade" className="bc-cookie-banner__link">
          Política de Privacidade
        </a>.
      </p>
      <div className="bc-cookie-banner__actions">
        <button className="bc-btn bc-btn--ghost bc-cookie-banner__btn-reject" onClick={onReject}>
          Recusar
        </button>
        <button className="bc-btn bc-btn--primary bc-cookie-banner__btn-accept" onClick={onAccept}>
          Aceitar
        </button>
      </div>
    </div>
  )
}
